import { defineCustomElement } from 'vue';
import App from './App.vue';

const WebComponent = defineCustomElement(App);
if (!customElements.get('my-web-component')) {
	customElements.define('my-web-component', WebComponent);
  }
  